import { MutatedPropertyType } from '../../../../constants/modelCompareData/types.mjs';
import '../../../../types/index.mjs';
import { StoreId } from '../../../../types/generated.mjs';
"use strict";
const transformPropertyValues = (propertyValues, formatMessage, storeId) => propertyValues.map(propertyValue => ({
  propertyId: propertyValue.propertyId,
  value: propertyValue.value.type === MutatedPropertyType.Translation ? {
    type: MutatedPropertyType.String,
    value: formatMessage ? typeof propertyValue.value.value === "string" ? formatMessage(propertyValue.value.value) : formatMessage(propertyValue.value.value(storeId || StoreId.Us)) : ""
  } : propertyValue.value
}));
export { transformPropertyValues };
//# sourceMappingURL=transformPropertyValues.mjs.map
